<template>
  <div class="content edit-page minus-margin20">
    <CommonStep :step-list="stepList"></CommonStep>
    <el-row class="content-2-col" id="rightForm" v-if="showContent">
      <BatchBaseInfo
        ref="baseInfo"
        v-show="active ===0"
        @next="next(arguments)"
      ></BatchBaseInfo>
      <BatchExcel
        ref="baseExcel"
        v-show="active ===1"
        :uploadInfo="uploadInfo"
        :baseInfo="baseInfo"
        :adSpaceModel="adSpaceModel"
        @next="next(arguments)"
        @previous="previous"
      ></BatchExcel>
      <BatchBusiness
        ref="BatchBusiness"
        v-show="active ===2"
        v-model="model"
        :excelInfo="excelInfo"
        :adSpaceModel="adSpaceModel"
        @next="next(arguments)"
        @previous="previous"
        @refresh="handleRefresh"
      ></BatchBusiness>
      <OtherConfig
        ref="OtherConfig"
        v-if="active ===3"
        v-model="model"
        :baseInfo="baseInfo"
        @next="next(arguments)"
        @refresh="handleRefresh"
      ></OtherConfig>
    </el-row>
  </div>
</template>
<script>

import BatchBaseInfo from './BatchBaseInfo';
import BatchExcel from '../adBatch/BatchExcel';
import BatchBusiness from '../adBatch/BatchBusiness';
import OtherConfig from '../adBatch/OtherConfig';
import CommonStep from '@/components/common/CommonStep';

export default {
  components: {
    BatchBaseInfo, BatchExcel, BatchBusiness, CommonStep, OtherConfig
  },
  watch: {
    active(newValue, oldValue) {
      this.handleChangeStepStatus()
    }
  },
  data() {
    return {
      // 步骤指示器
      active: 0,
      model: {},
      showContent: true,
      loading: false,
      targetEvent: 0,
      stepList: [
        {
          parent: '基础信息',
          status: '1'
        },
        {
          parent: '计划排期',
          status: this.active === 1 ? '1' : '0'
        },
        {
          parent: '定向条件',
          status: this.active === 2 ? '1' : '0'
        },
        {
          parent: '其他配置',
          status: this.active === 3 ? '1' : '0'
        },
        {
          parent: '完成',
          status: this.active === 2 ? '1' : '0'
        }
      ],
      uploadInfo: {},
      baseInfo: {},
      adSpaceModel: {},
      excelInfo: { channelIdList: [] }
    }
  },
  methods: {
    // 改变左侧步骤条状态
    handleChangeStepStatus() {
      if (this.active === 0 && this.stepList[this.active].status === '2') {
        this.stepList[0].status = '1'
        this.stepList[1].status = '0'
        this.stepList[2].status = '0'
        this.stepList[3].status = '0'
      } else if (this.active === 3 && this.stepList[this.active].status === '0') {
        let index = this.stepList.findIndex(item => item.status === '1')
        this.stepList[index].status = '2'
        this.stepList[index + 1].status = '1'
      } else if (this.active !== 3 && this.stepList[this.active].status === '0') {
        let index = this.stepList.findIndex(item => item.status === '1')
        if (index === 2) {
          this.stepList[index].status = '2'
          this.stepList[index + 1].status = '2'
          this.stepList[0].status = '1'
          this.stepList[1].status = '0'
          this.stepList[2].status = '0'
          this.stepList[3].status = '0'
        } else {
          this.stepList[index].status = '2'
          this.stepList[index + 1].status = '1'
        }
      } else {
        // 执行上一步时，把当前状态变为1，下一步状态变为0
        this.stepList[this.active].status = '1'
        this.stepList[this.active + 1].status = '0'
      }
    },
    handleRefresh() {
      this.active = 0
      this.handleChangeStepStatus()
      this.loading = true
      this.showContent = false
      setTimeout(() => {
        this.loading = false
        this.showContent = true
      }, 200)
    },
    previous(step) {
      if (step === 0) {
        if (this.$refs.baseInfo) {
          this.$refs.baseInfo.isSpaceChange = false
          this.$refs.baseInfo.isBaseInfoChange = false
        }
      }
      this.active = step
    },
    next(arr) {
      const step = arr[0]
      if (step === 1) {
        this.baseInfo = arr[1]
        this.uploadInfo = arr[2]
        this.adSpaceModel = arr[3]
      } else if (step === 2) {
        this.model = arr[1]
        this.excelInfo = arr[2]
      }
      this.active = step
    }
  }
}

</script>
<style lang="stylus" scoped>
  .content
    display flex
    flex-direction row
    height 100%

  .edit-page {
    overflow: hidden;
    height: calc(100vh - 60px);
  }

  .content-2-col {
    width: calc(100vw - 132px);
    padding: 16px;
    overflow: auto;
  }

  .content-3-col {
    width: calc(100vw - 132px);
    padding: 16px 0 16px 16px;
    overflow: auto;
  }

  .demo-ruleForm {
    max-width: 800px;
  }
.put-body {
  width: 100%;
  height: 100%;
}

.put-body::after {
  height: 0;
  clear: both;
  content: '';
  display: block;
}

.put-body .left {
  float: left;
  width: 180px;
  padding: 10px 0 10px 10px;
  height: 300px;
  background: #fff;
}

.put-body .main {
  padding: 10px;
  width: calc(100% - 220px);
  float: right;
}

.put-body .main .put-card {
  padding: 10px 10px 20px 10px;
}

</style>
